import React from "react";
import { NavbarAdminComponent } from "src/components/navbar";
import { SidebarAdminComponent } from "src/components/sidebar";

export default function AdminLayout({ children, title }) {
  const defaultTitle = "Reaksi Admin";
  const pageTitle = title ? `${title} | ${defaultTitle}` : defaultTitle;

  return (
    <>
      <div className="bg-gray-100">
        <NavbarAdminComponent />
        <div className="w-full flex">
          <SidebarAdminComponent />
          {children}
        </div>

        <div></div>
      </div>
    </>
  );
}
